// src/hooks/usePageTracking.ts
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

declare global {
  interface Window {
    gtag?: (
      command: string,
      targetId: string,
      config?: Record<string, any>
    ) => void;
  }
}

/**
 * Custom hook to track page views in Google Analytics 4 for Single Page Applications.
 * This hook automatically sends page_view events whenever the route changes.
 *
 * Usage:
 * - Import and call this hook in a component that's always mounted (e.g., App component)
 * - The hook will automatically track all route changes via React Router
 *
 * Note: Requires GA4 to be initialized with send_page_view: false to prevent duplicate tracking
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Only track if gtag is available (i.e., GA4 script has loaded)
    if (typeof window.gtag !== 'undefined') {
      window.gtag('event', 'page_view', {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
      });
    }
  }, [location]);
};
